(() => {
    const panel = document.getElementById('mobile-menu');

    if (!panel) {
        return;
    }

    const resetDrawerState = () => {
        panel.querySelectorAll('.is-open').forEach((element) => {
            if (element !== panel) {
                element.classList.remove('is-open');
            }
        });

        panel.querySelectorAll('[aria-expanded="true"]').forEach((element) => {
            element.setAttribute('aria-expanded', 'false');
        });

        panel.querySelectorAll('.mobile-titleRow').forEach((row) => {
            row.style.removeProperty('display');
        });
    };

    new MutationObserver(() => {
        if (panel.classList.contains('is-open')) {
            resetDrawerState();
        }
    }).observe(panel, { attributes: true, attributeFilter: ['class'] });
})();
